export default "__VITE_ASSET__1490ddfb__"